<div *ngIf="disabledFlag" class="loader"> </div>
<div class="container-fluid ">
    <div class="row">
        <div class="col-xl-12">
            <h3 class="text-black">Schedule Recurring...</h3>

            <p class="text-black">Do you want to continue to set this as recurring?</p>
            <table class="table mb-4 dataTable table-striped-custom table-bordered-custom" id="example5">
            <tbody class="ac-rowhov">

                <tr class="ac-table-hover-row align-middle">
                    <td style="width: 14.5%;"><span class="text-black font-w500 ac-invoice-num"></span>
                    <td style="width: 26%;"><span class="text-black font-w500 ac-invoice-num">{{ban}}</span></td>
                    <td><span class="text-black font-w500 ac-invoice-num">
                        <div ngbDropdown class="mySelectArrowCard" style="width: 60%;">
                        <button class="btn btn-outline-secondary" id="dropdownPriority" ngbDropdownToggle >
                          {{ defaultPaymentMethodId}}
                        </button>
                      </div></span>
                    </td>
                  
                </tr>

            </tbody>
        </table>

            <button type="button" class="btn ac-btn-outline-primary ac-butncancel mr-3" data-dismiss="modal"
                (click)="close()">Cancel</button>
            <button type="button" class="btn ac-btn-primary  mb-sm-0 mb-2" (click)="pay()"
                [disabled]="disabledFlag">Save</button>
        </div>
    </div>

</div>